import {Reflection} from "main.core";

const namespace = Reflection.namespace('BX.Citrus')

let instance;

export class ScrollTo {
    constructor() {
        window.addEventListener('popstate', (e) => {
            if (!e.state || !'scrollTo' in e.state) {
                return;
            }
            if (this.scroll(e.state.scrollTo)) {
                e.preventDefault();
            }
        });
        document.addEventListener('click', (e) => {
            const {target} = e;

            let selector = target.dataset.scrollTo;
            let title = target.textContent;
            if (!selector) {
                const parentScrollTo = target.closest('[data-scroll-to]');
                selector = parentScrollTo ? parentScrollTo.dataset.scrollTo : undefined;
                title = parentScrollTo ? parentScrollTo.textContent : undefined;
            }

            if (!selector) {
                return;
            }

            if (this.scroll(selector)) {
                e.preventDefault();
                history.pushState({scrollTo: selector}, title, selector)
            }
        });
    }

    scroll(to) {
        if (to === '#top') {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return true;
        }

        const scrollToElem = document.querySelector(to);
        if (!scrollToElem) {
            return false;
        }

        scrollToElem.scrollIntoView({
            behavior: 'smooth'
        });
        return true;
    }

    static initialize() {
        if (!instance) {
            instance = new ScrollTo();
        }
        return instance;
    }
}

namespace.ScrollTo = ScrollTo;
